export default __webpack_public_path__ + "static/media/DERMASTER_NEW_LOGO.ff6009c0.png";